import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import HotelRooms from '../../../Pages/RsvpRegistration/HotelRooms/HotelRooms';
import { guestHotelRooms } from '../../../services/adapters/guest';
import { toast } from 'react-toastify';

const AdminEditHotelRooms = ({ guest, event, onChange, dispatch, ...rest }) => {

    if (!guest) { return <></> }

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestHotelRooms(guest);

    const [form, setForm] = useState({
        hotel_required: false,
        roomData: [],
        hotel_justification: '',
        hotel_comments: '',
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.put(`/guests/${guest.id}/hotel-rooms`, form),
            {
                pending: 'Saving Hotel...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'Hotel rooms saved'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    useEffect(() => {
        setForm({ ...form, ...currentFormData });
    }, []);

    return (
        <>
            <button {...rest} onClick={handleShow}>Edit Hotel Rooms</button>

            <Modal className="guestpreview-modal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Hotel Rooms</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <HotelRooms
                        guest={guest}
                        formData={form}
                        isAdmin={true}
                        onChange={setForm}
                        errors={error}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditHotelRooms);
